module.exports = __webpack_public_path__ + "static/logo-cropped-1d61c683654fa8762e340eabc4e5c247.png";